import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

import { removeEmpty } from 'utils'

export const mapFieldReportTypeFilter = (item, index) => {
  return {
    ...item,
    index,
    key: uuidv4(),
    id: item?.value_list_id,
    name: item?.value_list_name,
    description: item?.value_list_description,
  }
}

export const getTaskStatusFilterListApi = (param) => {
  const params = removeEmpty({
    is_permission: !!param?.is_permission,
  })
  const config = {
    method: 'get',
    url: '/api/v1/filters/task_status',
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldReportTypeFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
